import API from "../../api";
import eventHelper from "@/utils/helpers/event";
import holidayHelper from "@/utils/helpers/holiday";
import moment from "@/utils/moment";
import { event } from "vue-analytics";

const SET_DISTRICT = "SET_DISTRICT";
const SET_AVAILABLE_PROFESSIONALS = "SET_AVAILABLE_PROFESSIONALS";
const SET_AVAILABLE_EVENTS = "SET_AVAILABLE_EVENTS";
const SET_STARTS_AT = "SET_STARTS_AT";
const SET_ENDS_AT = "SET_ENDS_AT";
const SET_DURATION = "SET_DURATION";
const SET_EVENT = "SET_EVENT";
const SET_LOADER = "SET_LOADER";
const RESET_STATE = "RESET_STATE";

const getDefaultState = () => {
  return {
    district: null,
    selectedProfessional: null,
    availableProfessionals: null,
    availableEvents: null,
    selectedEvent: null,
    duration: null,
    startsAt: null,
    endsAt: null,
    loader: false
  };
};

function daysOfPrecedenceFrom(day) {
  return moment(day).diff(moment(), "days") + 1;
}

function excludeHolidaysEvents(events) {
  const holidays = holidayHelper.daysWithDisabledPurchase();

  let filteredEvents = events.filter(
    event => !holidays.includes(moment(event.starts_at).format("MM-DD"))
  );
  return filteredEvents;
}

function setInitialHourSearch(time) {
  let currentTime = new moment().add(3, "hours");
  return time < currentTime ? currentTime : time;
}

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    setDistrict({ commit }, payload) {
      commit("SET_DISTRICT", payload);
    },

    setAvailableProfessionals({ commit, dispatch }, payload) {
      commit("SET_AVAILABLE_PROFESSIONALS", payload);
      dispatch("setProfessional", null);
    },

    setAvailableEvents({ commit, dispatch }, payload) {
      commit("SET_AVAILABLE_EVENTS", payload);
      if (payload) {
        dispatch("setEvent", null);
      }
    },

    setStartsAt({ commit, dispatch }, payload) {
      commit("SET_STARTS_AT", payload);
      dispatch("setEndsAt", null);
    },

    setEndsAt({ commit }, payload) {
      commit("SET_ENDS_AT", payload);
    },

    setEvent({ commit }, payload) {
      commit("SET_EVENT", payload);
    },

    setDuration({ commit }, payload) {
      commit("SET_DURATION", payload);
    },

    setLoader({ commit }, payload) {
      commit("SET_LOADER", payload);
    },

    resetState({ commit }) {
      commit("RESET_STATE");
    },

    async searchAvailableProfessionalsByDuration({
      rootState,
      state,
      commit,
      dispatch
    }) {
      dispatch("setLoader", true);

      try {
        let professionals = [];
        let events = [];
        let attempts = 1;
        let startsAt = moment(state.startsAt).subtract(1, "day");
        let endsAt = moment(state.endsAt).add(1, "day");

        while (professionals.length <= 0 && attempts < 10) {
          startsAt = setInitialHourSearch(startsAt.subtract(1, "day"));
          endsAt = endsAt.add(1, "day");
          attempts += 1;

          let response = await API.Professionals.getAvailablesByDuration({
            data: {
              attributes: {
                district_id: state.district.id,
                starts_at: startsAt.format("YYYY-MM-DD HH:mm:ss"),
                ends_at: endsAt.format("YYYY-MM-DD HH:mm:ss"),
                duration: state.duration * 60
              }
            }
          });

          professionals = response.professionals;
          events = excludeHolidaysEvents(response.events);

          //Verifica o sleeping time e caso necessário exclui o evento ou altera a hora inicial do mesmo
          events = events.filter(event => {
            if (eventHelper.checkSleepingTime(event)) return false;

            let validInitialHour = eventHelper.getValidInitialHour(event);
            event.starts_at = moment(event.starts_at)
              .hour(validInitialHour)
              .toDate();

            return true;
          });
        }

        events.forEach(suggestion => {
          let newOrderDay = rootState.newOrder.day;
          let newOrderStartsAt = rootState.newOrder.starts_at;
          let newOrderEndsAt = rootState.newOrder.ends_at;
          let originalDay = moment(newOrderDay).format("DD/MM/Y");
          let suggestionDay = moment(suggestion).format("DD/MM/Y");
          let newOrderDuration =
            parseInt(newOrderEndsAt.substr(0, 2)) -
            parseInt(newOrderStartsAt.substr(0, 2));

          event(
            "cliente",
            "click",
            `Compra:diaespecifico:semprofissionaldisponivel:sugestaodisponivel:bairro=${
              rootState.newOrder.address.district.display_name
            }:cidade=${
              rootState.newOrder.address.district.city.display_name
            }:diasemprofissional=${originalDay}:horainicial=${newOrderStartsAt}:duracao=${newOrderDuration}:diasdeantecedencia=${daysOfPrecedenceFrom(
              newOrderDay
            )}:diasugerido=${suggestionDay}:horainicial=${moment(
              suggestion.starts_at
            ).format("HH:mm")}:duracao=${suggestion.duration /
              60}:diasdeantecedencia=${daysOfPrecedenceFrom(suggestionDay)}`
          );
        });

        commit("SET_AVAILABLE_PROFESSIONALS", professionals);
        commit("SET_AVAILABLE_EVENTS", events);
      } catch (e) {
        throw e;
      }

      dispatch("setLoader", false);
    }
  },

  mutations: {
    [SET_DISTRICT](state, payload) {
      state.district = payload;
    },
    [SET_AVAILABLE_PROFESSIONALS](state, payload) {
      state.availableProfessionals = payload;
    },
    [SET_EVENT](state, payload) {
      state.selectedEvent = payload;
    },
    [SET_AVAILABLE_EVENTS](state, payload) {
      state.availableEvents = payload;
    },
    [SET_STARTS_AT](state, payload) {
      state.startsAt = payload;
    },
    [SET_ENDS_AT](state, payload) {
      state.endsAt = payload;
    },
    [SET_DURATION](state, payload) {
      state.duration = payload;
    },
    [SET_LOADER](state, payload) {
      state.loader = payload;
    },
    [RESET_STATE](state) {
      Object.assign(state, getDefaultState());
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/professionalsSuggestion.js